import {api} from "@/api";

// 获取数据监测列表
export const getList = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipment/getDataMonitorPageV2',
        method: 'POST',
        data: data
    })
}

// 获取数据监测列表  --  mqtt
export const getMqttList = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentMqtt/getData',
        method: 'POST',
        data: data
    })
}

// 获取数据监测列表--本地
export const getListLocal = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/getDataMonitorPage',
        method: 'POST',
        data: data
    })
}
// 获取数据监测列表--本地--直连设备
export const getListLocalLink = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/getDataMonitorPageWithDirect',
        method: 'POST',
        data: data
    })
}
// 获取数据监测列表--本地
export const getListLocalDataMonitorPage = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentLocal/getDataMonitorPageV2',
        method: 'POST',
        data: data
    })
}


// 保存分组
export const saveWithEquipmentApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/saveWithEquipment',
        method: 'POST',
        data: data
    })
}

// 保存分组--直连设备
export const saveWithEquipmentLinkApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/saveWithDirect',
        method: 'POST',
        data: data
    })
}

// 保存分组  ---  本地网关设备
export const saveLocalWithEquipmentApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/saveWithLocalEquipment',
        method: 'POST',
        data: data
    })
}

// 获取分组图表数据
export const getEquipmentDataGroupChartDataApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/getChartData',
        method: 'POST',
        data: data
    })
}
// 保存分组分享
export const saveShareGroupApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/saveSub',
        method: 'POST',
        data: data
    })
}

// 保存分组分享--本地
export const saveLocalShareGroupApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/saveSubWithLocalEquipment',
        method: 'POST',
        data: data
    })
}

// 获取分组列表
export const getShareGroupListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/listAllWithEquipmentId',
        method: 'POST',
        data: data
    })
}

// 获取分组列表---本地
export const getLocalShareGroupListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/listAllWithLocalEquipmentId',
        method: 'POST',
        data: data
    })
}

// 获取已分享的设备
export const getShareGroupDeviceApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/listSubEquipment',
        method: 'POST',
        data: data
    })
}
// 获取分组选项--本地设备
export const getLocalEquipmentGroupListApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/productShowDict/listGroupWithLocalEquipmentId',
        method: 'POST',
        data: data
    })
}
// 分组数据项显示---本地设备
export const getDataItemCheckWithLocalEquipmentApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/product/getDataItemCheckWithLocalEquipment',
        method: 'POST',
        data: data
    })
}

// 根据项目获取本地设备
export const getTreePrefixWithLocalEquipmentApi = (data) => {
    return api({
        headers: {
            memberId: window.localStorage.getItem('memberId'),
            Authorization: window.localStorage.getItem('Authorization'),
        },
        url: '/zouk/rest/equipmentTree/getTreePrefixWithLocalEquipment',
        method: 'POST',
        data: data
    })
}
